import { RootState } from '../rootReducer';
import { Language } from 'features/translator/types';

export const getActiveLanguage = (state: RootState): Language => state.translator.activeLanguage;
